/* ==========================================================================
   HBH Shipping Signal
   --------------------------------------------------------------------------
   Upgrades the safe, always-true wording that Liquid renders ("In stock")
   into the live wording ("Ships today — order by 4:00 pm ET") only when the
   clock actually agrees. Shopify can serve a cached page past the cutoff, so
   a same-day promise must never be baked into Liquid. This runs on every page
   view, cached or not.

   Paints every element that snippets/hbh-shipping-state.liquid rendered:
   the buy-box card, the sticky Add to Cart line, and the gallery flag.

   THE SHIPPING CALENDAR LIVES HERE, and deliberately not in a theme setting —
   when we ship is a business rule, not a design preference. The old countdown
   block exposed its cutoff in the Customizer and sat at 2 PM for months.

       Mon-Thu          4:00 pm ET
       Fri              noon ET
       Sat / Sun        closed
       CLOSED list      closed  — see below
       HALF_DAY list    noon ET — erev yom tov, same as a Friday

   The rule the two lists were built from, in Daniel's words: the store does
   not ship on any day the mail does not move in the U.S., and does not ship
   on yom tov or chol hamoed. Erev yom tov runs until noon, like a Friday.
   ========================================================================== */

(function () {
  // The snippet emits this script tag once per part, so a product page loads
  // it up to three times. One fetch, and this guard makes the extra
  // executions no-ops. Emitting it per part means the sticky line and the
  // gallery flag keep working even if the buy-box block is ever removed.
  if (window.__hbhShippingSignal) return;
  window.__hbhShippingSignal = true;

  var CUT_WD = 16; // 4:00 pm ET, Monday through Thursday
  var CUT_FRI = 12; // noon ET, Friday and every half day

  /* --------------------------------------------------------------------
     DAYS THE WAREHOUSE DOES NOT SHIP.

     Weekends are handled in code and are NOT listed here, so a holiday
     that falls on a Saturday or Sunday has no entry — which is why some
     festivals appear in one year and not the next.

     Federal holidays are here because no carrier moves freight on them.
     Verified for Thanksgiving and Christmas specifically: USPS, UPS and
     FedEx all suspend pickup and delivery, so working those days does not
     get a package out the door.

     Jewish dates were generated from the Hebrew calendar rather than
     copied from a website, and spot-checked against Hebcal for 5787 and
     5788. HBH-SHIPPING-CALENDAR.md has the same dates in plain English
     with the reason for each one — that is the file to hand to Eli.
     -------------------------------------------------------------------- */
  var CLOSED = [
    // ---------------------------------------------------------- 2026
    '2026-01-01', // New Year's Day
    '2026-01-19', // MLK Day
    '2026-02-16', // Presidents Day
    '2026-05-25', // Memorial Day
    '2026-06-19', // Juneteenth
    '2026-09-07', // Labor Day
    '2026-10-12', // Columbus Day
    '2026-11-11', // Veterans Day
    '2026-11-26', // Thanksgiving
    '2026-12-25', // Christmas Day
    // Pesach + chol hamoed
    '2026-04-02', '2026-04-03', '2026-04-06', '2026-04-07', '2026-04-08',
    '2026-04-09',
    // Shavuot
    '2026-05-22',
    // Yom Kippur
    '2026-09-21',
    // Sukkot + chol hamoed
    '2026-09-28', '2026-09-29', '2026-09-30', '2026-10-01', '2026-10-02',
    // ---------------------------------------------------------- 2027
    '2027-01-01', // New Year's Day
    '2027-01-18', // MLK Day
    '2027-02-15', // Presidents Day
    '2027-05-31', // Memorial Day
    '2027-07-05', // Independence Day
    '2027-09-06', // Labor Day
    '2027-10-11', // Columbus Day
    '2027-11-11', // Veterans Day
    '2027-11-25', // Thanksgiving
    // Pesach + chol hamoed
    '2027-04-22', '2027-04-23', '2027-04-26', '2027-04-27', '2027-04-28',
    '2027-04-29',
    // Shavuot
    '2027-06-11',
    // Sukkot + chol hamoed
    '2027-10-18', '2027-10-19', '2027-10-20', '2027-10-21', '2027-10-22',
    // ---------------------------------------------------------- 2028
    '2028-01-17', // MLK Day
    '2028-02-21', // Presidents Day
    '2028-05-29', // Memorial Day
    '2028-06-19', // Juneteenth
    '2028-07-04', // Independence Day
    '2028-09-04', // Labor Day
    '2028-10-09', // Columbus Day
    '2028-11-23', // Thanksgiving
    '2028-12-25', // Christmas Day
    // Pesach + chol hamoed
    '2028-04-11', '2028-04-12', '2028-04-13', '2028-04-14', '2028-04-17',
    '2028-04-18',
    // Shavuot
    '2028-05-31', '2028-06-01',
    // Rosh Hashanah
    '2028-09-21', '2028-09-22',
    // Sukkot
    '2028-10-05', '2028-10-06',
    // Sukkot + chol hamoed
    '2028-10-10', '2028-10-11', '2028-10-12', '2028-10-13',
    // ---------------------------------------------------------- 2029
    '2029-01-01', // New Year's Day
    '2029-01-15', // MLK Day
    '2029-02-19', // Presidents Day
    '2029-05-28', // Memorial Day
    '2029-06-19', // Juneteenth
    '2029-07-04', // Independence Day
    '2029-09-03', // Labor Day
    '2029-10-08', // Columbus Day
    '2029-11-12', // Veterans Day
    '2029-11-22', // Thanksgiving
    '2029-12-25', // Christmas Day
    // Pesach + chol hamoed
    '2029-04-02', '2029-04-03', '2029-04-04', '2029-04-05', '2029-04-06',
    // Shavuot
    '2029-05-21',
    // Rosh Hashanah
    '2029-09-10', '2029-09-11',
    // Yom Kippur
    '2029-09-19',
    // Sukkot + chol hamoed
    '2029-09-24', '2029-09-25', '2029-09-26', '2029-09-27', '2029-09-28',
    '2029-10-01', '2029-10-02',
    // ---------------------------------------------------------- 2030
    '2030-01-01', // New Year's Day
    '2030-01-21', // MLK Day
    '2030-02-18', // Presidents Day
    '2030-05-27', // Memorial Day
    '2030-06-19', // Juneteenth
    '2030-07-04', // Independence Day
    '2030-09-02', // Labor Day
    '2030-10-14', // Columbus Day
    '2030-11-11', // Veterans Day
    '2030-11-28', // Thanksgiving
    '2030-12-25', // Christmas Day
    // Pesach + chol hamoed
    '2030-04-18', '2030-04-19', '2030-04-22', '2030-04-23', '2030-04-24',
    '2030-04-25',
    // Shavuot
    '2030-06-07',
    // Yom Kippur
    '2030-10-07',
    // Sukkot + chol hamoed
    '2030-10-15', '2030-10-16', '2030-10-17', '2030-10-18',
    // ---------------------------------------------------------- 2031
    '2031-01-01', // New Year's Day
    '2031-01-20', // MLK Day
    '2031-02-17', // Presidents Day
    '2031-05-26', // Memorial Day
    '2031-06-19', // Juneteenth
    '2031-07-04', // Independence Day
    '2031-09-01', // Labor Day
    '2031-10-13', // Columbus Day
    '2031-11-11', // Veterans Day
    '2031-11-27', // Thanksgiving
    '2031-12-25', // Christmas Day
    // Pesach + chol hamoed
    '2031-04-08', '2031-04-09', '2031-04-10', '2031-04-11', '2031-04-14',
    '2031-04-15',
    // Shavuot
    '2031-05-28', '2031-05-29',
    // Rosh Hashanah
    '2031-09-18', '2031-09-19',
    // Sukkot + chol hamoed
    '2031-10-02', '2031-10-03', '2031-10-06', '2031-10-07', '2031-10-08',
    '2031-10-09', '2031-10-10',
  ];

  /* --------------------------------------------------------------------
     HALF DAYS — noon cutoff instead of 4:00 pm.
     Erev yom tov, which the store treats exactly like a Friday. An erev
     that falls on a Friday is already noon and is not repeated here; an
     erev that lands inside chol hamoed is closed outright, so it lives in
     CLOSED above and not here.
     -------------------------------------------------------------------- */
  var HALF_DAY = [
    // 2026
    '2026-04-01', // Erev Pesach
    '2026-05-21', // Erev Shavuot
    // 2027
    '2027-04-21', // Erev Pesach
    '2027-06-10', // Erev Shavuot
    // 2028
    '2028-04-10', // Erev Pesach
    '2028-05-30', // Erev Shavuot
    '2028-09-20', // Erev Rosh Hashanah
    '2028-10-04', // Erev Sukkot
    // 2029
    '2029-09-18', // Erev Yom Kippur
    // 2030
    '2030-04-17', // Erev Pesach
    '2030-06-06', // Erev Shavuot
    // 2031
    '2031-04-07', // Erev Pesach
    '2031-05-27', // Erev Shavuot
    '2031-09-17', // Erev Rosh Hashanah
    '2031-10-01', // Erev Sukkot
  ];

  // How far the two lists above were generated. Past this date the
  // component still handles weekends correctly and still says "Ships
  // today" on ordinary days, but it can no longer tell a holiday from an
  // ordinary Tuesday. It logs a console warning the moment that happens.
  var CLOSED_THROUGH = '2031-12-31';

  /* --------------------------------------------------------------------
     Eastern Time, correctly.
     The old countdown block used a fixed -5 offset, which is EST all year,
     so from mid-March to early November it ran a full hour out. Formatting
     into America/New_York lets the browser resolve DST for us.
     -------------------------------------------------------------------- */
  function nowET() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour12: false,
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }).formatToParts(new Date());

    var o = {};
    parts.forEach(function (p) {
      o[p.type] = p.value;
    });

    var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return {
      ymd: o.year + '-' + o.month + '-' + o.day, // the date in New York, not the visitor's
      day: days[o.weekday],
      hour: parseInt(o.hour, 10) % 24, // Intl emits "24" at midnight
      min: parseInt(o.minute, 10),
    };
  }

  /* --------------------------------------------------------------------
     Walking the calendar.
     All of this works on plain "YYYY-MM-DD" strings anchored at noon UTC.
     Noon rather than midnight on purpose: it keeps a date from sliding
     backwards a day when the clocks change.
     -------------------------------------------------------------------- */
  function asUTC(ymd) {
    return new Date(ymd + 'T12:00:00Z');
  }

  function addDays(ymd, n) {
    var d = asUTC(ymd);
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }

  function weekdayOf(ymd) {
    return asUTC(ymd).getUTCDay();
  }

  function shipsOn(ymd) {
    var w = weekdayOf(ymd);
    if (w === 0 || w === 6) return false;
    return CLOSED.indexOf(ymd) === -1;
  }

  function cutoffFor(ymd) {
    if (!shipsOn(ymd)) return null;
    if (weekdayOf(ymd) === 5) return CUT_FRI;
    return HALF_DAY.indexOf(ymd) === -1 ? CUT_WD : CUT_FRI;
  }

  // The next day we actually ship. Looks a month ahead: the longest run of
  // closed days on this calendar is twelve (Sukkot 2031, closed Oct 2
  // through Oct 13), and a run can butt up against a weekend on both ends.
  function nextShipDay(ymd) {
    for (var i = 1; i <= 31; i++) {
      var d = addDays(ymd, i);
      if (shipsOn(d)) return d;
    }
    return null;
  }

  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DAY_ABBR = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* --------------------------------------------------------------------
     Naming the next ship day. Three rungs, each as specific as it can
     honestly be:

        tomorrow          "Ships tomorrow"
        within six days   "Ships Tuesday"
        further out       "Ships Mon Oct 5"

     The third rung exists because of chol hamoed. Closing for the whole
     of Sukkot and Pesach produces twelve shutdowns longer than six days
     between 2026 and 2031, the longest of them twelve days. Across a gap
     like that "next business day" is not vague, it is wrong — a shopper
     reads it as tomorrow. The date is the only honest thing to print, and
     it is better for us too: someone who needs it sooner finds out now
     rather than after they have paid.
     -------------------------------------------------------------------- */
  function nameShipDay(todayYmd, targetYmd) {
    if (targetYmd === addDays(todayYmd, 1)) return 'Ships tomorrow';

    for (var i = 2; i <= 6; i++) {
      if (targetYmd === addDays(todayYmd, i)) {
        return 'Ships ' + DAY_NAMES[weekdayOf(targetYmd)];
      }
    }

    var d = asUTC(targetYmd);
    return (
      'Ships ' +
      DAY_ABBR[d.getUTCDay()] +
      ' ' +
      MON_ABBR[d.getUTCMonth()] +
      ' ' +
      d.getUTCDate()
    );
  }

  // Compact on purpose. The sticky bar is a fixed 600px on desktop and the
  // info column is squeezed between the thumbnail, the price and the button;
  // "— order by 4:00 pm ET" measured too wide to fit even at 1280px.
  function fmtHour(h) {
    if (h === 12) return 'noon';
    return (h > 12 ? h - 12 : h) + (h >= 12 ? 'pm' : 'am');
  }

  /* --------------------------------------------------------------------
     The words for right now.
     Returns { lead, rest, mins } — mins only when a countdown applies.
     `rest` is only ever used by the sticky bar, so it stays compact.
     -------------------------------------------------------------------- */
  // `rest` is only ever read by the sticky bar, which is a reminder surface
  // roughly 600px wide, not the place a shopper first learns the lead time.
  // Made to Order carries no qualifier there: "· ships in 7 business days"
  // measured as clipped at every desktop width, and a bare "· 7 business
  // days" is the ambiguity we just removed from the card. No number beats an
  // ambiguous one — the card above says it in full.
  function copyFor(state, days) {
    if (state === 'made') {
      return { lead: 'Made to order', rest: '' };
    }

    var t = nowET();

    // "Ships today" has to clear two gates, not one: the warehouse has to
    // be open at all today, and the cutoff has to still be ahead of us.
    // The first gate is the one holidays broke — before it existed, Labor
    // Day read "Ships today — order within 6h".
    var cut = cutoffFor(t.ymd);
    if (cut !== null) {
      var minsLeft = cut * 60 - (t.hour * 60 + t.min);
      if (minsLeft > 0) {
        return {
          lead: 'Ships today',
          rest: ' · by ' + fmtHour(cut) + ' ET',
          mins: minsLeft,
        };
      }
    }

    var next = nextShipDay(t.ymd);
    return {
      lead: next ? nameShipDay(t.ymd, next) : 'In stock',
      rest: '',
    };
  }

  // Compact, so the card holds one line all the way down to a 360px phone.
  // "3 hours 12 minutes" wrapped to two lines on every phone width tested.
  // 61 -> "1h 1m" · 60 -> "1h" · 12 -> "12m"
  function humanize(mins) {
    var h = Math.floor(mins / 60);
    var m = mins % 60;
    return (h ? h + 'h' : '') + (h && m ? ' ' : '') + (m ? m + 'm' : '');
  }

  function paintOne(el) {
    var state = el.dataset.state;
    var days = parseInt(el.dataset.days, 10) || 7;
    var part = el.dataset.part;
    var c = copyFor(state, days);

    if (part === 'card') {
      // The Made to Order card is fully server-rendered and never time-
      // sensitive — leave it alone rather than blanking its lead time.
      if (state !== 'quick') return;

      var label = el.querySelector('[data-hbh-label]');
      if (label) label.textContent = c.lead;

      // Empty after the cutoff and at weekends: "Ships tomorrow" and
      // "Ships Monday" say everything on their own.
      var live = el.querySelector('[data-hbh-live]');
      if (live) {
        live.innerHTML = c.mins ? ' — order within <strong>' + humanize(c.mins) + '</strong>' : '';
      }
      return;
    }

    var lead = el.querySelector('[data-hbh-lead]');
    if (lead) lead.textContent = c.lead;

    var rest = el.querySelector('[data-hbh-rest]');
    if (rest) rest.textContent = c.rest || '';
  }

  function paint() {
    document.querySelectorAll('[data-hbh-ship]').forEach(paintOne);
  }

  // Say so loudly and once, while there is still someone to hear it. Past
  // this date the component is still safe on weekends and still correct on
  // ordinary days — it just cannot see holidays any more, so a holiday
  // reads "Ships today" again.
  if (nowET().ymd > CLOSED_THROUGH && window.console && console.warn) {
    console.warn(
      '[HBH Shipping Signal] The shipping calendar ran out on ' +
        CLOSED_THROUGH +
        '. Holidays are no longer being skipped, so a holiday now reads ' +
        '"Ships today". Regenerate CLOSED and HALF_DAY in ' +
        'assets/hbh-shipping-signal.js.'
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }

  // The sticky bar mounts a beat after the rest of the page.
  setTimeout(paint, 400);
  setTimeout(paint, 1500);

  // Tick the wording as the cutoff approaches.
  setInterval(paint, 60000);

  // A tab left open in the background has its timers throttled, so repaint
  // the moment it comes back rather than waiting for the next interval.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) paint();
  });

  // Survive the theme editor re-rendering a section or selecting a block.
  document.addEventListener('shopify:section:load', paint);
  document.addEventListener('shopify:block:select', paint);
})();